import { render, staticRenderFns } from "./WorkRights.vue?vue&type=template&id=9ca334f2"
import script from "./WorkRights.vue?vue&type=script&lang=js"
export * from "./WorkRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports